import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnDestroy,
} from "@angular/core";
import { FormGroup, FormBuilder, FormArray, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import Swal from "sweetalert2";
import { UserManagementService } from "../user-management.service";
import { ModalService } from "src/app/service/modal.service";
import { AlertifyService } from "src/app/UtilityService/alertify.service";

@Component({
    selector: "app-Signup-confirm",
    templateUrl: "./signup-confirm.component.html",
    styleUrls: ["./signup-confirm.component.css"],
    standalone: false
})
export class SignupconfirmComponent implements OnInit, OnDestroy {
  @Input() username?: any;
  public signupFormConfirm: FormGroup;
  public dashboardOptions = [];
  timeLeft: number = 60; // 1 minute timer
  interval: any;
  isSubmitDisabled: boolean = true;

  constructor(
    private fb: FormBuilder,
    private modalSvc: ModalService,
    private activeModal: NgbActiveModal,
    private alertify: AlertifyService,
    private userService: UserManagementService
  ) {
    this.startTimer();
  }

  ngOnInit(): void {
    this.signupFormConfirm = this.fb.group({
      inputField: ["", [Validators.required, Validators.minLength(10)]],
    });
  }

  addFormGroup(): void {
    const formGroup = this.fb.group({
      inputField: ["", [Validators.required, Validators.maxLength(20)]],
    });
  }

  submit(): void {
    if (!this.signupFormConfirm.errors) {
      let code = this.signupFormConfirm.controls.inputField.value;
      const request = {
        username: this.username,
        code: code,
      };
      this.userService.confirmsignUp(request).then((response: any) => {
        if (response && response.status == 1) {
          this.activeModal.dismiss();
          this.showAlert("Registered Successfully.Admin will contact you");
        } else {
          this.showAlert("Sorry Invalid User.Please contact to Admin.");
        }
      });

      this.activeModal.close();
    } else {
      this.alertify.error("Form not valid.");
    }
  }

  public dissmissModal() {
    this.activeModal.dismiss();
  }

  ngOnDestroy(): void {
    //this.subscription.unsubscribe();
  }
  startTimer() {
    this.isSubmitDisabled = false; // Disable the resend button
    this.timeLeft = 60; // Reset the timer
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.isSubmitDisabled = true; // Enable the resend button
        clearInterval(this.interval); // Clear the timer
      }
    }, 1000);
  }

  resendOtp() {
    this.startTimer(); // Restart the timer on resend
  }
  showAlert(msg) {
    Swal.fire({
      title: msg,
      showClass: {
        popup: "animate__animated animate__fadeInDown",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutUp",
      },
    });
  }
}
